// packages
import React from 'react';

// types
import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import { DeclarationTypeResponse } from 'generated/index';

// components
import { DeclarationTypeForm } from '../DeclarationTypeForm/DeclarationTypeForm';

export const CreateDeclarationTypeDrawer: React.FC<
  FormComponentProps<DeclarationTypeResponse>
> = ({ handleClose, rowId, rows = [] }) => {
  // Find the declaration type by rowId from the rows prop
  const rowData = rowId ? rows.find((row) => row.id === rowId) : undefined;

  return (
    <DeclarationTypeForm
      handleClose={handleClose}
      rowData={rowData}
      rows={rows}
    />
  );
};
